export default {"src":"/_next/static/media/bkgd-howitworks.239d7b5c.svg","height":450,"width":1440};